export default function getSuffixForAcabado(acabado: string): string {
  const acabadoUpper = acabado.toUpperCase()

  switch (acabadoUpper) {
    case 'LARA':
      return ' LA'
    case 'RUSTIK':
      return ' Ru'
    case 'RUSTIK2':
      return ' R2'
    case 'LINEAL':
      return ' LI'
  }

  if (acabadoUpper.includes('LARA') || acabadoUpper.startsWith('LA')) {
    return ' LA'
  }

  if (acabadoUpper.includes('RUSTIK') || acabadoUpper.startsWith('RU')) {
    return ' Ru'
  }

  if (acabadoUpper.includes('RUSTIK2') || acabadoUpper.startsWith('R2')) {
    return ' R2'
  }

  if (acabadoUpper.includes('LINEAL')) {
    return ' LI'
  }

  return ''
}
